import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, useLocation } from 'react-router-dom';
var OldPushNotifications = function () {
    var pathname = useLocation().pathname;
    var pathNameArray = pathname.split('/');
    var orgId = pathNameArray[2];
    var appId = pathNameArray[4];
    var createPage = pathNameArray[6] === 'new';
    return createPage ? (_jsx(Navigate, { to: "/organizations/".concat(orgId, "/apps/").concat(appId, "/push/notifications/new") })) : (_jsx(Navigate, { to: "/organizations/".concat(orgId, "/apps/").concat(appId, "/push/notifications") }));
};
export default OldPushNotifications;
